import type {QueryClient} from "@tanstack/react-query";

import {NOTIFICATION_FEED_QUERY_KEY} from "../hooks/use-notification-feed";
import {notificationFeedService} from "../services";
import {useNotificationFeedStore} from "../store";
import type {NotificationItem} from "../types";

/** Optimistic + API mark-read for a single feed row (e.g. when opening the subject). */
export async function markNotificationItemRead(
  item: NotificationItem,
  queryClient?: QueryClient,
): Promise<void> {
  if (item.read_at || item.discarded_at) {
    return;
  }

  useNotificationFeedStore.getState().markReadLocal([item.id]);

  try {
    await notificationFeedService.markReadByIds([item.id]);
  } catch {
    // Still navigate / open subject if mark-read fails.
  }

  if (queryClient) {
    void queryClient.invalidateQueries({queryKey: [NOTIFICATION_FEED_QUERY_KEY]});
  }
}
